import { render } from "./AdminMultiselect.vue?vue&type=template&id=36636645&ts=true"
import script from "./AdminMultiselect.vue?vue&type=script&lang=ts"
export * from "./AdminMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__